var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMerchantVisibilityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 6.66667C1.66797 6.66667 5.39893 2.5 10.0013 2.5C14.6036 2.5 18.3346 6.66667 18.3346 6.66667",
    stroke: "#8C8C8C",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9546 10.8709C18.208 11.2261 18.3346 11.4038 18.3346 11.6667C18.3346 11.9296 18.208 12.1073 17.9546 12.4625C16.8162 14.0589 13.909 17.5 10.0013 17.5C6.09362 17.5 3.18639 14.0589 2.048 12.4625C1.79464 12.1073 1.66797 11.9296 1.66797 11.6667C1.66797 11.4038 1.79464 11.2261 2.048 10.8709C3.18639 9.27454 6.09362 5.83337 10.0013 5.83337C13.909 5.83337 16.8162 9.27454 17.9546 10.8709Z",
    stroke: "#8C8C8C",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.6666C12.5 10.2859 11.3807 9.16663 10 9.16663C8.61925 9.16663 7.5 10.2859 7.5 11.6666C7.5 13.0474 8.61925 14.1666 10 14.1666C11.3807 14.1666 12.5 13.0474 12.5 11.6666Z",
    stroke: "#8C8C8C",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantVisibilityIcon);
export default __webpack_public_path__ + "static/media/MerchantVisibilityIcon.3ddf47eef4e29e6783cfe65432aa69a9.svg";
export { ForwardRef as ReactComponent };